import { MetadataFieldRendererProps } from '@/asset/components/metadata/field-renderer';
import { PRODUCT_FIELD_TYPE_DATA } from '@/constants/product-field-type';
import { TextField } from '@mui/material';
import { FieldValues, useFormContext, useWatch } from 'react-hook-form';

/**
 * Renders a text field in the metadata form.
 *
 * IMPORTANT: This component must be wrapped in a FormProvider from react-hook-form.
 */
export function TextFieldRenderer(props: MetadataFieldRendererProps) {
  const { metadata, error, fieldIndex, setValue } = props;
  const { control } = useFormContext<FieldValues>();
  const value = useWatch({
    control,
    name: `metadata.${fieldIndex}.value`,
  });
  const isMultiline = metadata.field.type === 'multiline_text';
  const isInteger = metadata.field.type === 'integer';
  const isNumber = metadata.field.type === 'number';
  const isNumeric = isInteger || isNumber;
  return (
    <TextField
      fullWidth
      size="small"
      label={`${metadata.field.label} (${PRODUCT_FIELD_TYPE_DATA[metadata.field.type].fieldTypeLabel})`}
      minRows={3}
      maxRows={3}
      multiline={isMultiline}
      type="text"
      inputProps={{
        inputMode: isNumeric ? 'numeric' : 'text',
      }}
      error={!!error}
      onChange={(e) => {
        const input = e.target.value;
        setValue(input);
      }}
      value={value ? String(value) : ''}
      helperText={error?.message}
      sx={{ gridRow: isMultiline ? 'span 2' : 'span 1' }}
    />
  );
}
